import { createStore } from 'vuex'
import auth from './modules/auth'
import core from './modules/core'
import user from './modules/management-account/user'
import role from './modules/management-account/role'

import analytic from './modules/analytic'
import lpd from './modules/lpd'
import dashboard from './modules/dashboard'
import company from './modules/company'
import employee from './modules/employee'
import companySubdivision from './modules/company-subdivision'
import forms from './modules/forms'
import report from './modules/report'
import claim from './modules/claim'
import logActivity from './modules/log-activity'
import invoice from './modules/payment/invoice'
import paymentConfirmation from './modules/payment/payment-confirmation'
import journalContribution from './modules/payment/journal-contribution'
import paymentCompany from './modules/payment/payment-company'
import bank from './modules/bank'
import sourceScope from './modules/master-data/source-scope'
import masterData from './modules/master-data/index'
import notification from './modules/notification'
import menu from './modules/menu'
import bulk from './modules/bulk'
import updated from './modules/updated'
import notificationPayment from './modules/notification-payment'
import emailBroadcast from './modules/email-broadcast'
import configurationRetirement from './modules/configuration-retirement'
import termsCondition from './modules/terms-condition'
import employeeMutation from './modules/employee-mutation'
import employeeExistingSync from './modules/employee-existing-sync'

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    core,
    user,
    role,
    analytic,
    lpd,
    dashboard,
    company,
    employee,
    companySubdivision,
    forms,
    report,
    claim,
    logActivity,
    invoice,
    paymentConfirmation,
    journalContribution,
    paymentCompany,
    bank,
    sourceScope,
    masterData,
    notification,
    menu,
    bulk,
    updated,
    notificationPayment,
    emailBroadcast,
    configurationRetirement,
    termsCondition,
    employeeMutation,
    employeeExistingSync
  }
})
